module.exports = __webpack_public_path__ + "img/verified-icon.b6f4326c.svg";